import { render } from "./LabelValue.vue?vue&type=template&id=5b54a5b4&scoped=true"
import script from "./LabelValue.vue?vue&type=script&lang=js"
export * from "./LabelValue.vue?vue&type=script&lang=js"

import "./LabelValue.vue?vue&type=style&index=0&id=5b54a5b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b54a5b4"]])

export default __exports__